import styled from 'styled-components';

export const ListIconWrapper = styled.div`
  cursor: pointer;
`;
